import { render, staticRenderFns } from "./LastIncidents.vue?vue&type=template&id=66239cf4&scoped=true"
import script from "./LastIncidents.vue?vue&type=script&lang=js"
export * from "./LastIncidents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66239cf4",
  null
  
)

export default component.exports